import type { ActionFlowState } from '../types.action-flow'

/**
 * The flow's transaction has confirmed and its awaited `onSuccess` is still running (indexer sync
 * wait, refetch). The reducer keeps `flowState: 'execution'` throughout, so consumers deciding
 * "still working, the user can bail" versus "already succeeded" must exclude this window
 * explicitly: it lasts seconds after a successful transaction.
 */
export function isActionFlowFinalizing(state: ActionFlowState) {
  return state.flowState === 'execution' && state.stepState === 'finalizing'
}
